import { render, staticRenderFns } from "./Manuals.vue?vue&type=template&id=4df1cbb6"
import script from "./Manuals.vue?vue&type=script&lang=js"
export * from "./Manuals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports